var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-transcricoes" },
    [
      _c(
        _vm.navegavel ? "button" : "div",
        {
          tag: "component",
          staticClass: "ia-cliente-transcricoes__rotulo ia-texto-selo",
          attrs: { type: _vm.navegavel ? "button" : null },
          on: { click: _vm.aoClicar }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.rotulo))]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          !_vm.carregando
            ? _c(
                "span",
                {
                  staticClass: "ia-sidebar-contador ml-auto",
                  attrs: { "data-test": "ia-cliente-transcricoes-contador" }
                },
                [_vm._v(" " + _vm._s(_vm.contador) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.carregando
        ? _c(
            "ul",
            { staticClass: "ia-cliente-transcricoes__lista" },
            _vm._l(_vm.LINHAS_PENDENTES, function(linha) {
              return _c(
                "li",
                { key: linha.chave },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.ICONE,
                      size: _vm.TAMANHO_ICONE,
                      color: "var(--neutral-300)"
                    }
                  }),
                  _c(
                    "span",
                    { staticClass: "ia-cliente-transcricoes__texto" },
                    [
                      _c(
                        "BaseLoadingSkeleton",
                        _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_NOME, false)
                      ),
                      _c(
                        "BaseLoadingSkeleton",
                        _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_META, false)
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm.vazio
        ? _c(
            "p",
            { staticClass: "ia-cliente-transcricoes__vazio ia-texto-auxiliar" },
            [_vm._v(" Nenhuma transcrição ")]
          )
        : _c(
            "ul",
            { staticClass: "ia-cliente-transcricoes__lista" },
            _vm._l(_vm.itens, function(item) {
              return _c(
                "li",
                { key: item.chave },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.ICONE,
                      size: _vm.TAMANHO_ICONE,
                      color: "var(--neutral-700)"
                    }
                  }),
                  _c(
                    item.href ? "a" : "span",
                    {
                      tag: "component",
                      staticClass: "ia-cliente-transcricoes__texto",
                      class: {
                        "ia-cliente-transcricoes__texto--link": item.href
                      },
                      attrs: {
                        href: item.href || null,
                        target: item.href ? "_blank" : null,
                        rel: item.href ? "noopener noreferrer" : null
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "ia-cliente-transcricoes__linha" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "ia-cliente-transcricoes__nome ia-texto-auxiliar"
                            },
                            [_vm._v(_vm._s(item.nome))]
                          ),
                          item.nota
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "ia-cliente-transcricoes__nota ia-texto-auxiliar"
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "ia-cliente-transcricoes__ponto",
                                    style: { background: item.corDoSentimento }
                                  }),
                                  _vm._v(" " + _vm._s(item.nota) + " ")
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      item.meta
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "ia-cliente-transcricoes__meta ia-texto-auxiliar"
                            },
                            [_vm._v(" " + _vm._s(item.meta) + " ")]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }